import script from "./CustomerDashboardContacts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDashboardContacts.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__